// Lista de slugs de provincia válidos (mismo mapa que `PROVINCIA_SLUG_TO_CODE`
// en /app/backend/subastas.py). Hardcodeado en frontend para que el dispatcher
// `/subastas/:slug` decida instantáneamente (sin round-trip) entre página de
// provincia y ficha de subasta.

export const PROVINCIA_SLUG_TO_CODE = {
  // 52 provincias
  "alava": "01",
  "albacete": "02",
  "alicante": "03",
  "almeria": "04",
  "avila": "05",
  "badajoz": "06",
  "islas-baleares": "07",
  "barcelona": "08",
  "burgos": "09",
  "caceres": "10",
  "cadiz": "11",
  "castellon": "12",
  "ciudad-real": "13",
  "cordoba": "14",
  "a-coruna": "15",
  "cuenca": "16",
  "girona": "17",
  "granada": "18",
  "guadalajara": "19",
  "gipuzkoa": "20",
  "huelva": "21",
  "huesca": "22",
  "jaen": "23",
  "leon": "24",
  "lleida": "25",
  "la-rioja": "26",
  "lugo": "27",
  "madrid": "28",
  "malaga": "29",
  "murcia": "30",
  "navarra": "31",
  "ourense": "32",
  "asturias": "33",
  "palencia": "34",
  "las-palmas": "35",
  "pontevedra": "36",
  "salamanca": "37",
  "santa-cruz-de-tenerife": "38",
  "cantabria": "39",
  "segovia": "40",
  "sevilla": "41",
  "soria": "42",
  "tarragona": "43",
  "teruel": "44",
  "toledo": "45",
  "valencia": "46",
  "valladolid": "47",
  "bizkaia": "48",
  "zamora": "49",
  "zaragoza": "50",
  "ceuta": "51",
  "melilla": "52",
  // Alias bilingües / históricos
  "vizcaya": "48",
  "guipuzcoa": "20",
  "la-coruna": "15",
  "baleares": "07",
  "tenerife": "38",
};

export function isProvinciaSlug(slug) {
  if (!slug || typeof slug !== "string") return false;
  return Object.prototype.hasOwnProperty.call(PROVINCIA_SLUG_TO_CODE, slug.toLowerCase());
}
